import React from "react";
import {
  Footer,
  Blog,
  Possibilty,
  Features,
  WhatGPT3,
  Header,
} from "./containers";
import { Cta, Brand, Navbar } from "./components";
import "./App.css"

function App() {
  return (
    <div className="App">
     <div className="gradient__bg">
      <Navbar/>
      <Header/>

     </div>
     <Brand/>
     <WhatGPT3/>
     <Features/>
     <Possibilty/>
     <Cta/>
     <Blog/>
     <Footer/>


    </div>
  );
}

export default App;
